(function () {
  'use strict';

  angular.module('eclipseApp.core')
    .factory('dataExtraAPIService',
      ['$http', 'uteEndpoint', '$q', '$rootScope','$window', function ($http, uteEndpoint, $q, $rootScope, $window) {

      var model = {
          dataExtraList : null,
          overageRate: null ,
          planName : '',
          planNameFR : '',
          planSize: null
      };

      var service = {
        getDataExtraList: function () {
          return model.dataExtraList;
        },
        setDataExtraList: function (dataExtraList) {
          model.dataExtraList = dataExtraList;
        },
        getPlanName: function () {
          return model.planName;
        },
        setPlanName: function (planName) {
          model.planName = planName;
        },
        getPlanNameFR: function () {
          return model.planNameFR;
        },
        setPlanNameFR: function (planNameFR) {
          model.planNameFR = planNameFR;
        },
        getOverageRate: function () {
          return model.overageRate;
        },
        setOverageRate: function (overageRate) {
          model.overageRate = overageRate;
        },
        getPlanSize: function () {
          return model.planSize;
        },
        setPlanSize: function (planSize) {
          model.planSize = planSize;
        }
      };

      return service;
  }]);
})();



